// src/shared-components/forms/add-artwork/components/CriticalChangesPopup.jsx
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon        from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text         from '@/shared-components/text/components/Text';

import './styles/CriticalChangesPopup.css';

export default function CriticalChangesPopup({
  open,
  loading = false,
  onSendReview,
  onRevert,
  onClose,
  userType = "gallery",          // ← valor por defecto
}) {
  // ————— copy según rol ————————————————————————
  const bodyCopy =
  userType === "artist"
    ? `You’ve updated the main artwork image or changed its dimensions by more than 5 cm. To ensure accuracy, our team will conduct a quick review, usually within a few hours. While we review, your artwork will be temporarily unavailable to collectors.`
    : `You’ve updated the artist, the main artwork image or changed its dimensions by more than 5 cm. To ensure accuracy, our team will conduct a quick review, usually within a few hours. While we review, your artwork will be temporarily unavailable to collectors.`;

  return (
    <GenericPopup
      open={open}
      opacity
      onClick={onClose}              // clic sobre overlay = cerrar
      className="artwork-confirmation-dialog remove-scrollbar"
    >
      {/* Este div detiene la propagación para que clicks dentro NO cierren */}
      <div onClick={e => e.stopPropagation()}>
        <div className="artwork-confirmation-dialog-popup__header">
          <Text className="artwork-confirmation-dialog-popup__header-text">
            Important changes detected
          </Text>
          <XIcon
            className="artwork-confirmation-dialog-popup__close"
            onClick={onClose}
          />
        </div>

        {/* BODY */}
        <Text
          paragraph
          className="artwork-confirmation-dialog-popup__text"
        >
          {bodyCopy}
        </Text>

        {/* ACTIONS */}
        <div className="artwork-confirmation-dialog__action-buttons element-non-selectable">
          <ContinueButton
            loading={loading}
            onClick={onSendReview}
            className="artwork-confirmation-dialog__save-exit-button"
          >
            Send for review
          </ContinueButton>

          <ContinueButton
            look="secondary"
            onClick={onRevert}
            className="artwork-confirmation-dialog__yes-exit-button"
          >
            Revert changes
          </ContinueButton>
        </div>
      </div>
    </GenericPopup>
  );
}
